// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"535":"b1a03905","760":"3d1991b4"}[chunkId] + ".js";
};